import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import '../../styles/projectcss/Residential.css';

// Import residential project images
import residential1 from '../../assets/images/projects/RESIDENCIAL/R1.jpg';
import residential2 from '../../assets/images/projects/RESIDENCIAL/R2.jpg';
import residential3 from '../../assets/images/projects/RESIDENCIAL/R3.jpg';
import residential4 from '../../assets/images/projects/RESIDENCIAL/R4.jpg';
import residential5 from '../../assets/images/projects/RESIDENCIAL/R5.jpg';
import residential6 from '../../assets/images/projects/RESIDENCIAL/R7.jpg';
import residential7 from '../../assets/images/projects/RESIDENCIAL/R8.jpg';
import residential8 from '../../assets/images/projects/RESIDENCIAL/R9.jpg';
import residential9 from '../../assets/images/projects/RESIDENCIAL/R3.jpg';
import residential10 from '../../assets/images/projects/RESIDENCIAL/R11.jpg';
import residential11 from '../../assets/images/projects/RESIDENCIAL/R12.jpg';
import residential12 from '../../assets/images/projects/RESIDENCIAL/R13.jpg';
import residential13 from '../../assets/images/projects/RESIDENCIAL/R14.jpg';
import residential14 from '../../assets/images/projects/RESIDENCIAL/R15.jpg';
import residential15 from '../../assets/images/projects/RESIDENCIAL/R16.jpg';
import residential16 from '../../assets/images/projects/RESIDENCIAL/R17.jpg';
import residential17 from '../../assets/images/projects/RESIDENCIAL/R18.jpg';
import residential18 from '../../assets/images/projects/RESIDENCIAL/R19.jpg';
import residential19 from '../../assets/images/projects/RESIDENCIAL/R20.jpg';
import residential20 from '../../assets/images/projects/RESIDENCIAL/R21.jpg';
import residential21 from '../../assets/images/projects/RESIDENCIAL/R22.jpg';
import residential22 from '../../assets/images/projects/RESIDENCIAL/R23.jpg';
import residential23 from '../../assets/images/projects/RESIDENCIAL/R24.jpg';
import residential24 from '../../assets/images/projects/RESIDENCIAL/R7.jpg';
import residential25 from '../../assets/images/projects/RESIDENCIAL/R26.jpg';
import residential26 from '../../assets/images/projects/RESIDENCIAL/R27.jpg';
import residential27 from '../../assets/images/projects/RESIDENCIAL/R28.jpg';
import residential28 from '../../assets/images/projects/RESIDENCIAL/R29.jpg';
import residential29 from '../../assets/images/projects/RESIDENCIAL/R30.jpg';
import residential30 from '../../assets/images/projects/RESIDENCIAL/R31.jpg';
import residential31 from '../../assets/images/projects/RESIDENCIAL/R32.jpg';
import residential32 from '../../assets/images/projects/RESIDENCIAL/R33.jpg';
import residential33 from '../../assets/images/projects/RESIDENCIAL/R34.jpg';
import residential34 from '../../assets/images/projects/RESIDENCIAL/R35.jpg';
import residential35 from '../../assets/images/projects/RESIDENCIAL/R38.jpg';
import residential36 from '../../assets/images/projects/RESIDENCIAL/R39.jpg';
import residential37 from '../../assets/images/projects/RESIDENCIAL/R40.jpg';
import residential38 from '../../assets/images/projects/RESIDENCIAL/R41.jpg';
import residential39 from '../../assets/images/projects/RESIDENCIAL/R42.jpg';
import residential40 from '../../assets/images/projects/RESIDENCIAL/R43.jpg';
import residential41 from '../../assets/images/projects/RESIDENCIAL/R44.jpg';
import residential42 from '../../assets/images/projects/RESIDENCIAL/R45.jpg';
import residential43 from '../../assets/images/projects/RESIDENCIAL/R26.jpg'; 
import residential44 from '../../assets/images/projects/RESIDENCIAL/R16.jpg';
import residential45 from '../../assets/images/projects/RESIDENCIAL/R27.jpg';
import residential46 from '../../assets/images/projects/RESIDENCIAL/R2.jpg';
import residential47 from '../../assets/images/projects/RESIDENCIAL/R10.jpg';
import residential48 from '../../assets/images/projects/RESIDENCIAL/R20.jpg';
import residential49 from '../../assets/images/projects/RESIDENCIAL/R30.jpg';
import residential50 from '../../assets/images/projects/RESIDENCIAL/R40.jpg';
import residential51 from '../../assets/images/projects/RESIDENCIAL/R21.jpg';
import residential52 from '../../assets/images/projects/RESIDENCIAL/R33.jpg';
import residential53 from '../../assets/images/projects/RESIDENCIAL/R43.jpg';


const Residential = () => {
  const [imageLoading, setImageLoading] = useState({});
  const navigate = useNavigate();

  const residentialProjects = [
    { id: 1, image: residential1 },
    { id: 2, image: residential2 },
    { id: 3, image: residential3 },
    { id: 4, image: residential4 },
    { id: 5, image: residential5 },
    { id: 6, image: residential6 },
    { id: 7, image: residential7 },
    { id: 8, image: residential8 },
    { id: 9, image: residential9 },
    { id: 10, image: residential10 },
    { id: 11, image: residential11 },
    { id: 12, image: residential12 },
    { id: 13, image: residential13 },
    { id: 14, image: residential14 },
    { id: 15, image: residential15 },
    { id: 16, image: residential16 },
    { id: 17, image: residential17 },
    { id: 18, image: residential18 },
    { id: 19, image: residential19 },
    { id: 20, image: residential20 },
    
    { id: 21, image: residential21 },
    { id: 22, image: residential22 },
    { id: 23, image: residential23 },
    { id: 24, image: residential24 },
    { id: 25, image: residential25 },
    { id: 26, image: residential26 },
    { id: 27, image: residential27 },
    { id: 28, image: residential28 },
    { id: 29, image: residential29 },
    { id: 30, image: residential30 },
    { id: 31, image: residential31 },
    { id: 32, image: residential32 },
    { id: 33, image: residential33 },
    { id: 34, image: residential34 },
    { id: 35, image: residential35 },
    { id: 36, image: residential36 },
    { id: 37, image: residential37 },
    { id: 38, image: residential38 },
    { id: 39, image: residential39 },
    { id: 40, image: residential40 },
    { id: 41, image: residential41 },
    { id: 42, image: residential42 },
    { id: 43, image: residential43 },
    { id: 44, image: residential44 },
    { id: 45, image: residential45 },
    { id: 46, image: residential46 },
    { id: 47, image: residential47 },
    { id: 48, image: residential48 },
    { id: 49, image: residential49 },
    { id: 50, image: residential50 },
    { id: 51, image: residential51 },
    { id: 52, image: residential52 },
    { id: 53, image: residential53 },
    
  ];

  const projectHighlights = [
    {
      title: "Quality Craftsmanship",
      description: "Every residential project we undertake is built with meticulous attention to detail and superior craftsmanship. We use only the highest quality materials and employ skilled artisans to ensure lasting beauty and durability.",
      icon: "🏗️"
    },
    {
      title: "Modern Design & Innovation",
      description: "Our residential designs blend contemporary aesthetics with functional living spaces. We incorporate smart home technology, energy-efficient systems, and innovative architectural solutions to create homes that are both beautiful and practical.",
      icon: "💡"
    },
    {
      title: "Client-Centric Approach",
      description: "We work closely with our clients throughout the construction process, ensuring their vision is brought to life. Our transparent communication and commitment to excellence have earned us a reputation for delivering beyond expectations.",
      icon: "🤝"
    }
  ];

  const handleImageLoad = (projectId) => {
    setImageLoading(prev => ({ ...prev, [projectId]: false }));
  };

  const handleImageError = (projectId) => {
    setImageLoading(prev => ({ ...prev, [projectId]: false }));
  };

  const handleInquireProject = (project) => {
    navigate('/contact', { 
      state: { 
        selectedService: "Residential Project",
        projectDetails: project
      }
    });
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0, scale: 0.9 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  const filterVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 200
      }
    }
  };

  return (
    <motion.div 
      className="residential-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="container">
        {/* Header Section */}
        <motion.div className="residential-header" variants={itemVariants}>
          <h1>Residential Projects</h1>
          <p className="page-intro">
            Discover our exceptional portfolio of residential properties, from luxury villas to modern apartments. 
            Each project reflects our commitment to quality craftsmanship, innovative design, and client satisfaction.
          </p>

          {/* Filter Buttons Header */}
          <motion.div 
            className="projects-filter"
            variants={filterVariants}
          >
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/projects')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              All Projects
            </motion.button>
            <motion.button
              className={`filter-btn ${'residential' === 'residential' ? 'active' : ''}`}
              onClick={() => navigate('/residential')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Residential
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/commercial')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Commercial
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/industrial')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Industrial
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/religious')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Religious
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/educational')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Educational
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/road')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Road
            </motion.button>
          </motion.div>
        </motion.div>

        {/* Image Gallery Section */}
        <motion.section className="gallery-section" variants={itemVariants}>
          <h2>Project Gallery</h2>
          <p className="section-subtitle">A visual journey through our exceptional residential constructions</p>
          <div className="gallery-grid">
            {residentialProjects.map((project, index) => (
              <motion.div
                key={project.id}
                className={`gallery-item gallery-item-${index + 1}`}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="gallery-image">
                  <img 
                    src={project.image} 
                    alt={`Residential Project ${project.id}`}
                    onLoad={() => handleImageLoad(`gallery-${project.id}`)}
                    onError={() => handleImageError(`gallery-${project.id}`)}
                  />
                  {/* <div className="gallery-overlay">
                    <div className="gallery-info">
                      <motion.button 
                        className="inquire-btn"
                        onClick={() => handleInquireProject(project)}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                      >
                        Inquire Now
                      </motion.button>
                    </div>
                  </div> */}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* Project Highlights Section */}
        <motion.section className="highlights-section" variants={itemVariants}>
          <h2>Why Choose Our Residential Projects</h2>
          <div className="highlights-grid">
            {projectHighlights.map((highlight, index) => (
              <motion.div
                key={index}
                className="highlight-card"
                whileHover={{ y: -10, transition: { type: "spring", stiffness: 300 } }}
              >
                <div className="highlight-icon">{highlight.icon}</div>
                <h3>{highlight.title}</h3>
                <p>{highlight.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* CTA Section */}
        <motion.section className="cta-section" variants={itemVariants}>
          <div className="cta-content">
            <h2>Ready to Build Your Dream Home?</h2>
            <p>Let's discuss your residential project requirements and bring your vision to life with our expert construction services.</p>
            <motion.button 
              className="cta-button"
              onClick={() => navigate('/contact')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Start Your Project
            </motion.button>
          </div>
        </motion.section>
      </div>
    </motion.div>
  );
};

export default Residential;